import React from "react";

import Title from "./Title";
import { useTranslation } from "react-i18next";

export default function PrivacyPolicy() {
  const { t } = useTranslation();

  return (
    <section id={t("data-security")} className="data-security-section">
      <div className="data-security-bg background-img">
        <Title title={t("data-security")} />
      </div>

      <h3 className="margin-top-l">{t("general-title")}</h3>
      <p>{t("general-intro")}</p>

      <h3 className="margin-top-l">{t("collected-data-title")}</h3>
      <p>{t("collected-data-text")}</p>

      <h3 className="margin-top-l">{t("legal-basis-title")}</h3>
      <p>
        {t("legal-basis-text")
          .split("\n")
          .map((line, idx) => (
            <span key={idx}>
              {line}
              <br />
            </span>
          ))}
      </p>

      <h3 className="margin-top-l">{t("data-disclosure-title")}</h3>
      <p>{t("data-disclosure-text")}</p>

      <h3 className="margin-top-l">{t("storage-duration-title")}</h3>
      <p>{t("storage-duration-text")}</p>

      <h3 className="margin-top-l">{t("rights-title")}</h3>
      <p>{t("rights-text")}</p>

      <h3 className="margin-top-l">{t("security-title")}</h3>
      <p>{t("security-text")}</p>

      <h3 className="margin-top-l">{t("plugins-title")}</h3>
      <p>{t("plugins-text")}</p>

      <h3 className="margin-top-l">{t("changes-title")}</h3>
      <p>{t("changes-text")}</p>
    </section>
  );
}
